module.exports = __webpack_public_path__ + "static/media/vitaminas.ad4977fc.png";